export default __webpack_public_path__ + "static/media/hht1_ep6_minisitcom_02.c6f717af.png";